import type { Job } from "../types/Job";

const BLANK = "—";

export interface JobPreviewFacts {
	where: string;
	company: string;
	season: string;
	acres: string;
	depth: string;
	lab: string;
}

type PreviewedJob = Pick<
	Job,
	"growerName" | "farmName" | "companyName" | "season" | "boundaryAcres" | "depth" | "labName"
>;

/** A job's facts as a search preview shows them. A blank number arrives as 0, so 0 reads as blank. */
export function jobPreviewFacts(job: PreviewedJob): JobPreviewFacts {
	return {
		where: [job.growerName, job.farmName].filter(Boolean).join(" / "),
		company: job.companyName,
		season: job.season || BLANK,
		acres: job.boundaryAcres > 0 ? `${Math.round(job.boundaryAcres * 10) / 10} ac` : BLANK,
		depth: job.depth > 0 ? `${job.depth} in` : BLANK,
		lab: job.labName || BLANK,
	};
}
